import * as React from 'react';
import styled from 'styled-components';
import { LoginState, PlayerData } from './Models/ApplicationInterfaces';
import { generatePlayerData } from './utility/PlayerDataGenerator';
import { LobbyScreen } from './Views/Lobby';
import { Login } from './Views/Login';
declare global {
    // tslint:disable-next-line:interface-name
    interface Window { WebSocket: any; MozWebSocket:any;}
}
interface State {
	gameplayState:LoginState,
	
	isLoading:boolean,
	playerData: PlayerData;
}
class App extends React.Component<{},State> {
	public state: State = {
		gameplayState: LoginState.notConnected,
		isLoading: false,
		playerData: generatePlayerData(),
	}; // 24 = tele, 21 = distract, 19 = door
	public componentDidMount() {
		this.onResizeWindow();
		window.addEventListener("resize", this.onResizeWindow);

		// Testing Debug Stuff
		(global as any).setDebug = (val: boolean) => {(global as any).debug = val; this.forceUpdate()}
	}
	public componentWillUnmount(){
		window.removeEventListener("resize", this.onResizeWindow);
	}
  public render() { 
    return (
		<Wrapper>
			{this.getScreen(this.state.gameplayState)}
		</Wrapper>
	);
  }
  private getScreen (state: LoginState) {
	switch(state) {
		case LoginState.notConnected:
			return <Login changeState={this.setGameState} setLoading={this.setLoading} playerData={this.state.playerData} setPlayerData={this.setPlayerData}/>
		case LoginState.inLobby:
			return <LobbyScreen changeState={this.setGameState} setLoading={this.setLoading}/>	
	}
	return "OH NO!"
	}
	private onResizeWindow = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh",`${vh}px`)
		this.forceUpdate();
	}
	
	private setPlayerData = (playerData: PlayerData) => this.setState({playerData});
	private setLoading = (loading: boolean) => this.setState({isLoading:loading});
	private setGameState = (newState: LoginState) => this.setState({gameplayState:newState}); 
	
}
const Wrapper = styled.div`
	overscroll-behavior: contain;
	width:100%;
	height: 100vh; /* Fallback for browsers that do not support Custom Properties */
	height: calc(var(--vh, 1vh) * 100);
	margin: auto;
	touch-action: "pan-down";
	
`;
export default App;



// WEBPACK FOOTER //
// ./src/App.tsx